import { TemplateRef } from '@angular/core';
import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { Observable } from 'rxjs';

export type IEditStatus = 'error' | 'success' | 'warning';

export interface IEditableRow {
  [key: string]: NzSafeAny;
}

export interface IEditableBaseCol {
  name?: string;
  titleTipContent?: string | TemplateRef<{}>;
  titleTipIcon?: string;
  key: string;
  editable?: boolean;
  value?: (val: string) => string;
  validators?: ValidatorFn[] | ValidatorFn;
  onChange?: (fg: FormGroup, editRow?: IEditableRow) => void;
}

export interface IEditableTextCol extends IEditableBaseCol {
  type?: EEditableColType.text; // 编辑类型
  inputType?: 'text' | 'number';
}

export interface IEditableSelectCol extends IEditableBaseCol {
  type: EEditableColType.select; // 编辑类型
  options: IEditableSelectOptions;
}
export interface IEditableTemplateCol extends IEditableBaseCol {
  type: EEditableColType.template; // 编辑类型
  ref: string;
}

export type IEditableCol = IEditableSelectCol | IEditableTextCol | IEditableTemplateCol;

export type IEditableSelectOptions = IEditableSelectOption[] | Observable<IEditableSelectOption[]>;

export interface IEditableSelectOption {
  name: string;
  value: string;
}

export interface IFormControls {
  [key: string]: AbstractControl;
}

export interface IValidatorError {
  key: string;
  message: NzSafeAny;
}

export enum EEditableColType {
  'text' = 'text',
  'select' = 'select',
  'template' = 'template'
}
